import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import _ from 'underscore';
import SelectGroup from '../form/select-group';

class Component extends BaseComponent {
    componentDidMount() {
        this.decks = {};

        let slug = 'universal-waite';

        this.props.decks.map(deck => {
            if (deck.deck == this.props.user.favorite_deck_id) {
                this.setState({
                    value: deck.slug,
                });
            }

            this.decks[deck.slug] = deck.name;

            if (
                this.props.user
                &&
                !isNaN(this.props.user.favorite_deck_id)
                &&
                this.props.user.favorite_deck_id == deck.deck
            ) {
                slug = deck.slug;
            }
        });

        this.props.requireDeck(slug);
    }

    render() {
        return (
            <tarot-deck>
                <row className='is-wrap'>
                    {this.renderDeckImage()}
                    <column className='is-12'>
                        <SelectGroup
                            name='favorite_deck_id'
                            value={this.state.value}
                            placeholder='SELECT TAROT DECK'
                            options={this.decks}
                            onChange={this.handleChange}
                        />
                    </column>
                </row>
            </tarot-deck>
        );
    }

    renderDeckImage = () => {
        if (this.props.deck) {
            return [
                <column className='is-2 is-hidden-mobile'>
                    &nbsp;
                </column>,
                <column className='is-8 is-12-mobile has-text-center has-padding-20-bottom'>
                    <img
                        src={`https://gfx.tarot.com/images/decks/deck-image/${this.props.deck.slug}.jpg`}
                        alt={this.props.deck.name}
                    />
                </column>,
            ];
        }

        return null;
    }

    handleChange = (e) => {
        this.setState({
            value: e.target.value,
        });

        this.props.requireDeck(e.target.value);

        this.props.decks.map(deck => {
            if (deck.slug == e.target.value) {
                this.props.onChange(e.target.name, deck.deck);
            }
        });
    }
}

const mapStateToProps = (state) => ({
    deck: state.deck,
    decks: state.decks,
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    requireDeck: (deck) => dispatch({ type: 'deck:required', payload: deck }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
